export default __webpack_public_path__ + "static/media/409.7a1582f4.jpg";